export const ROUTES = {
  // Public routes
  HOME: '/',
  LANDING: '/landing',
  SAMPLE: '/sample',
  ANIMATED: '/animated',
  FEATURE_LANDING: '/feature-landing',

  // Base app route
  APP: '/w',

  // Workspace routes
  WORKSPACE: '/w/space',
  WORKSPACE_FOLDER: (folderId: string) => `/w/space/${folderId}`,

  // Account
  ACCOUNT: '/w/account',

  // Design routes
  DESIGN: (designId: string) => `/w/design/${designId}`,

  // Admin routes
  ADMIN: '/w/admin',
  ADMIN_USERS: '/w/admin/users',
  ADMIN_CATALOGS: '/w/admin/catalogs',

  // Terms
  TERMS: '/terms',

  // // Documentation
  // DOCUMENTATION: '/docs',

  // Auth action routes
  AUTH_ACTION: '/__/auth/action',
};

// Helper to type-check route paths
export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
